import { useFormContext, useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { DisplayModes } from 'services/webedi/types';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { useDateConfigurations } from 'components/DataTable/cells/WebEDI/cellHelpers';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormInput } from 'components/Form/SchemableFormInput/SchemableFormInput';
import { Translate } from 'components/Translate/Translate';

type DateFieldProps = {
  field: ui.DateField | ui.DateTimeField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};
export const DateField = ({ field, fieldId, isReadOnly, mode, variant }: DateFieldProps) => {
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const fieldState = service.useFieldStateFromAnnotations(fieldId);
  const popoverItem = service.useItemByFieldPath(fieldId);
  const setCurrentItem = service.setCurrentItem;
  const { formattedValue } = useDateConfigurations({
    value,
    mode,
  });

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={formattedValue}
        label={field.label}
        error={popoverItem}
        fieldId={fieldId}
        onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
        description={field.description}
      />
    );
  }
  return (
    <SchemableFormInput
      type={field.type === ui.FieldTypes.date ? 'date' : 'datetime-local'}
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={popoverItem}
      {...register(fieldId)}
      value={formattedValue}
      onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      valueDescription={field.value_description}
      fieldState={fieldState}
    />
  );
};
